module.exports = __webpack_public_path__ + "img/logo-psiqueasy-store-dark.15b7c473.png";